import { invalidateCache } from 'api/urql/helpers/mutation';

export const bulkDeleteDraftJobRequests = (results, args, cache, info) => {
  // handlers go here
  invalidateCache('paginatedDraftJobRequests')(results, args, cache, info);
};
